<template>
  <nav class="navbar navbar-main navbar-expand-lg full-width-navbar" id="navbarBlur">
    <div class="container-fluid">
      <!-- Mobile sidebar toggle -->
      <button
          type="button"
          class="mobile-nav-toggle"
          aria-label="Toggle navigation menu"
          @click="toggleMobileSidebar"
      >
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
      </button>

      <!-- Left side: Logos -->
      <div class="navbar-brand-container">
        <RouterLink class="navbar-brand" to="/">
          <img
              src="https://driqq8crwypb5.cloudfront.net/Public_Website_Images/images/Project%20Blue_Logo2.png"
              class="navbar-brand-img"
              :alt="t('App.sidebarMenu.appName')"
          />
        </RouterLink>
        <div class="additional-image-container">
          <img
              src="https://driqq8crwypb5.cloudfront.net/Public_Website_Images/images/Proxima_Logo4.png"
              class="additional-image"
              alt="Additional Image"
          />
        </div>
      </div>

      <div class="navbar-center d-none d-lg-flex">
        <div class="welcome-text" v-if="SUBSCRIPTION_INFO.fullname">
          Welcome back, <strong>{{ SUBSCRIPTION_INFO.fullname }}</strong>
        </div>
      </div>

      <!-- Right side: User menu-->
      <div class="navbar-right">
        <!-- <div class="desktop-nav-items d-none d-lg-flex">
          <NavItems />
          <NotificationsMenu />
          <Notes />
        </div> -->
        <!-- Profile drawer (notifications, subscriptions, logout) stays reachable at every width -->
        <ProfileDrawer />
      </div>
    </div>
  </nav>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { NIcon } from "naive-ui";
import { ArrowLeft } from "@vicons/tabler";
import NotificationsMenu from "./Notifications.vue";
import NavItems from './NavItems.vue'
import Logout from "./Logout.vue";
import Notes from "./Notes.vue";
import ProfileDrawer from "./ProfileDrawer.vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { ROUTES } from "../../routes/names";
import { SUBSCRIPTION_INFO } from "../../composables/subscription";

const router = useRouter();
const route = useRoute();
const { t } = useI18n();

const toggleMobileSidebar = () => {
  document.dispatchEvent(new CustomEvent('mobile-sidebar-toggle'));
};

onMounted(() => {
  if (typeof window.bootstrap !== 'undefined') {
    // Bootstrap is available
  }
});
</script>

<style scoped>
.full-width-navbar {
  background: linear-gradient(to right, rgb(10, 26, 60), rgba(33, 60, 229)) !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 0.75rem 0;
  min-height: 70px;
  position: relative;
}

.container-fluid {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Mobile sidebar toggle (hamburger) */
.mobile-nav-toggle {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  width: 40px;
  height: 40px;
  margin-right: 0.75rem;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
}

.mobile-nav-toggle .hamburger-line {
  display: block;
  width: 22px;
  height: 2px;
  background: #ffffff;
}

@media (max-width: 1199.98px) {
  .mobile-nav-toggle {
    display: flex;
  }
}

/* Left side - Brand logos */
.navbar-brand-container {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.navbar-brand {
  padding: 0;
  margin-right: 0;
  color: white !important;
  text-decoration: none;
}

.navbar-brand-img {
  height: 2.2rem;
  max-height: none;
}

.additional-image-container {
  margin-left: 0;
  display: flex;
  align-items: center;
}

.additional-image {
  height: 2rem;
  max-height: none;
  object-fit: contain;
}

/* Center - Welcome text / Back button (desktop only) */
.navbar-center {
  flex: 1;
  justify-content: center;
  align-items: center;
}

.welcome-text {
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.95rem;
  letter-spacing: 0.01em;
  padding: 0.4rem 1.5rem;
  white-space: nowrap;
}

.welcome-text strong {
  color: #ffffff;
  font-weight: 600;
}

/* Right side - Controls and menu */
.navbar-right {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-shrink: 0;
}

.desktop-nav-items {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

@media (max-width: 991.98px) {
  .navbar-center {
    display: none !important;
  }

  .desktop-nav-items {
    display: none !important;
  }
}

@media (max-width: 767.98px) {
  .full-width-navbar {
    min-height: 60px;
  }

  .container-fluid {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .navbar-brand-img {
    height: 1.8rem;
  }

  .additional-image-container {
    margin-left: 0.5rem;
  }

  .additional-image {
    height: 1.6rem;
  }
}

@media (max-width: 575.98px) {
  .navbar-brand-img {
    height: 1.6rem;
  }

  .additional-image {
    height: 1.4rem;
  }

  .additional-image-container {
    margin-left: 0.5rem;
  }

  .mobile-nav-toggle {
    width: 34px;
    height: 34px;
    margin-right: 0.5rem;
  }

  .navbar-right {
    gap: 0.5rem;
  }
}

* {
  border-radius: 0 !important;
}

:deep(.btn) {
  border-radius: 0 !important;
}

:deep(.dropdown-menu) {
  border-radius: 0 !important;
}

:deep(.dropdown-item) {
  border-radius: 0 !important;
}
</style>